// use lodash! https://lodash.com/docs/4.17.15
import doMegaMenus from './components/doMegaMenus'

const fndryThemeInitWrapper = () => {
	doMegaMenus();
};

window.fndryThemeInitWrapper = fndryThemeInitWrapper;

// eslint-disable-next-line no-unused-expressions
document.body ? fndryThemeInitWrapper() : document.addEventListener( 'DOMContentLoaded', fndryThemeInitWrapper, false );
